import React from 'react'
import { BrowserRouter,NavLink, Route, Routes } from 'react-router-dom';
import './App.css';
import EqtlSelector from './components/EqtlSelector/';
import PqtlSelector from './components/PqtlSelector/';
const Home = () => <h1>Human Kidney Single Cell Transcriptome</h1>;
function App() {
  return (
    <BrowserRouter  basename={process.env.PUBLIC_URL}>
<div>
      <NavLink  className={({ isActive }) => (isActive ? 'active' : 'inactive')} to='/eQTL'>eQTL</NavLink>{' '}
      <NavLink  className={({ isActive }) => (isActive ? 'active' : 'inactive')} to='/pQTL'>pQTL</NavLink>{' '}
      <Routes>
        <Route path="/eQTL" element={<EqtlSelector/>} />
        <Route path="/pQTL" element={<PqtlSelector/>} />
        <Route render={() => <h1>Page not found</h1>} />
      </Routes>
</div>
</BrowserRouter>
  );
}
export default App;
